import React, { useState } from 'react';
import { Card, Button, Badge, Spinner } from 'react-bootstrap';

function ActiveProgramCard({ activeProgram, onContinue, onViewProgram }) {
  const [isLoading, setIsLoading] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return 'Today';
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else if (diffDays < 7) {
      return `${diffDays} days ago`;
    } else if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    } else {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }
  };

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      await onContinue(activeProgram);
    } catch (err) {
      console.error('Error continuing program:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const renderProgressInfo = () => {
    if (!activeProgram.current_workout_name) {
      return (
        <div className="progress-text text-muted">
          <i className="fas fa-flag me-1"></i>
          Ready to start first workout
        </div>
      );
    }

    return (
      <div className="progress-text text-muted">
        <i className="fas fa-check-circle me-1 text-success"></i>
        Last: {activeProgram.current_workout_name}
      </div>
    );
  };

  return (
    <Card className="active-program-card h-100">
      <Card.Body>
        {/* Active badge */}
        <div className="mb-2">
          <Badge bg="success" className="active-badge">
            <i className="fas fa-fire me-1"></i>
            ACTIVE
          </Badge>
        </div>

        {/* Program name */}
        <Card.Title className="mb-2">
          <i className="fas fa-calendar-week me-2 text-purple"></i>
          {activeProgram.program_name}
        </Card.Title>

        {/* Progress info */}
        <div className="mb-2">
          {renderProgressInfo()}
        </div>

        {/* Started date */}
        <div className="text-muted small mb-3">
          <i className="fas fa-calendar-alt me-1"></i>
          Started: {formatDate(activeProgram.started_at)}
        </div>

        {/* Action buttons */}
        <div className="d-grid gap-2">
          <Button
            variant="success"
            onClick={handleContinue}
            disabled={isLoading}
            className="btn-continue"
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Loading...
              </>
            ) : (
              <>
                <i className="fas fa-play-circle me-2"></i>
                Continue Program
              </>
            )}
          </Button>

          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => onViewProgram(activeProgram.program_id)}
            disabled={isLoading}
          >
            <i className="fas fa-eye me-1"></i>
            View Details
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ActiveProgramCard;
